// Permanent, subtle "DEMO MODE" indicator pinned to the bottom-right corner.
// Always visible across every route so demo screenshots are never mistaken for
// production. pointer-events:none so it never blocks interaction.
export default function DemoWatermark() {
  return (
    <div
      className="pointer-events-none fixed bottom-3 right-3 z-[9998] select-none"
      aria-hidden="true"
    >
      <div className="rounded-md bg-black/55 px-2.5 py-1 text-right leading-tight text-white/90 shadow-lg backdrop-blur-sm">
        <div className="text-[10px] font-semibold tracking-[0.14em]">DEMO MODE</div>
        <div className="text-[9px] text-white/70">Sample Data Only</div>
      </div>
    </div>
  );
}
